// Pinia plugin (doc 04 §3, plugins/pinia.ts).
import { createPinia } from 'pinia'

export const pinia = createPinia()

export default pinia
